// cursor.js — Custom cursor + magnetic card tilt

let dot, ring;
let mouseX = -100, mouseY = -100;
let ringX = -100, ringY = -100;
let hovering = false;

function lerp(a, b, t) { return a + (b - a) * t; }

function animateRing() {
  ringX = lerp(ringX, mouseX, 0.13);
  ringY = lerp(ringY, mouseY, 0.13);
  ring.style.transform = `translate(${ringX - 17}px, ${ringY - 17}px)`;
  requestAnimationFrame(animateRing);
}

export function initCursor() {
  dot  = document.getElementById('cursor-dot');
  ring = document.getElementById('cursor-ring');
  if (!dot || !ring) return;

  document.body.classList.add('has-custom-cursor');

  document.addEventListener('mousemove', (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
    dot.style.transform = `translate(${mouseX - 2.5}px, ${mouseY - 2.5}px)`;
    dot.style.opacity  = '1';
    ring.style.opacity = '';
  });

  document.addEventListener('mouseleave', () => {
    dot.style.opacity  = '0';
    ring.style.opacity = '0';
  });

  document.addEventListener('mouseenter', () => {
    dot.style.opacity  = '1';
    ring.style.opacity = '';
  });

  window.addEventListener('blur', () => {
    dot.style.opacity  = '0';
    ring.style.opacity = '0';
    document.body.classList.remove('cursor-hover');
  });

  window.addEventListener('focus', () => {
    dot.style.opacity  = '1';
    ring.style.opacity = '';
  });

  animateRing();
  initCardTilt();
}

function initCardTilt() {
  const cards = document.querySelectorAll('.project-card');

  cards.forEach((card) => {
    const glow = card.querySelector('.card-glow');

    card.addEventListener('mouseenter', () => {
      document.body.classList.add('cursor-hover');
    });

    card.addEventListener('mouseleave', () => {
      document.body.classList.remove('cursor-hover');
      card.style.transform = '';
      if (glow) glow.style.background = '';
    });

    card.addEventListener('mousemove', (e) => {
      const rect = card.getBoundingClientRect();
      const cx = rect.left + rect.width  / 2;
      const cy = rect.top  + rect.height / 2;

      // Normalized -1..1
      const dx = (e.clientX - cx) / (rect.width  / 2);
      const dy = (e.clientY - cy) / (rect.height / 2);

      // Tilt (max ±8deg)
      const tiltX = dy * -7;
      const tiltY = dx *  7;

      card.style.transform = `perspective(900px) rotateX(${tiltX}deg) rotateY(${tiltY}deg) translateZ(6px)`;

      // Move glow to cursor position
      if (glow) {
        const gx = ((e.clientX - rect.left) / rect.width)  * 100;
        const gy = ((e.clientY - rect.top)  / rect.height) * 100;
        glow.style.background = `radial-gradient(circle at ${gx}% ${gy}%, var(--card-glow) 0%, transparent 60%)`;
      }
    });
  });

  // Expand ring on any interactive element
  const interactives = document.querySelectorAll('a, button');
  interactives.forEach((el) => {
    el.addEventListener('mouseenter', () => document.body.classList.add('cursor-hover'));
    el.addEventListener('mouseleave', () => document.body.classList.remove('cursor-hover'));
  });
}
